import { FC, useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { Formik } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Form from 'components/Form';
import AccordionController from 'components/AccordionController';
import FlightDetails from 'components/FlightDetails';
import Details from 'components/FlightEditGeneralInfoDetails';

import { useErrorHandler } from 'lib';
import {
  FlightEditGeneralInfoFormMutation,
  FlightEditGeneralInfoFormMutation$data,
} from '__generated__/FlightEditGeneralInfoFormMutation.graphql';
import { FlightEditGeneralInfo_flight$key } from '__generated__/FlightEditGeneralInfo_flight.graphql';

type FormValues = {
  expired: boolean;
};

type Props = {
  flight: FlightEditGeneralInfo_flight$key;
};

const FlightEditGeneralInfo: FC<Props> = props => {
  const errorHandler =
    useErrorHandler<FlightEditGeneralInfoFormMutation$data>();

  const flight = useFragment(
    graphql`
      fragment FlightEditGeneralInfo_flight on Flight {
        id
        expired

        ...FlightEditGeneralInfoDetails_flight
        ...FlightDetails_flight
      }
    `,
    props.flight
  );

  const { id, expired } = flight;

  const [update, loading] =
    useMutation<FlightEditGeneralInfoFormMutation>(graphql`
      mutation FlightEditGeneralInfoFormMutation(
        $id: ID!
        $input: FlightUpdateInput!
      ) {
        updateFlight(id: $id, input: $input) {
          expired
        }
      }
    `);

  const handleSubmit = useCallback(
    (input: FormValues) => {
      update({
        variables: { id, input },
        ...errorHandler,
      });
    },
    [errorHandler, id, update]
  );

  return (
    <Formik<FormValues> initialValues={{ expired }} onSubmit={handleSubmit}>
      <Form loading={loading}>
        <FlightDetails flight={flight} />

        <AccordionController id="flightGeneralInfo">
          <Details flight={flight} />
        </AccordionController>
      </Form>
    </Formik>
  );
};

export default FlightEditGeneralInfo;
